module.exports = __webpack_public_path__ + "static/media/penguin-image.3880e008.jpeg";